import { useCallback } from 'react';

import { usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { tracker } from 'app-components/utils/core';

import useChatDisclaimer from 'components/Dialogs/ChatDisclaimer/dispatcher';

// onConsent only runs once the disclaimer dialog has actually cleared, so callers
// can't mutate chat state (e.g. dispatch openChat) ahead of user consent.
export const useChatDisclaimerGate = () => {
  const [disclaimerSeen] = usePreferenceV2('aiChatDisclaimerSeen', false);
  const showChatDisclaimer = useChatDisclaimer();

  const requestOpenChat = useCallback(
    (onConsent: () => void) => {
      if (!disclaimerSeen) {
        tracker.track('AIChatDisclaimerShown');
        showChatDisclaimer({ continue: onConsent });
        return;
      }
      onConsent();
    },
    [disclaimerSeen, showChatDisclaimer],
  );

  return { requestOpenChat };
};
